import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';
import { getOrganisation, listContacts, listOrganisations } from '@mkcore/crm/schema';
import type { z } from '@mkcore/shared';
import { call } from '@/lib/api';

// Query options of organisations and contacts; keys start with 'org' so SSE messages invalidate them.

type In<A extends { input: z.ZodTypeAny }> = z.input<A['input']>;

export const organisationsQuery = (q: Omit<In<typeof listOrganisations>, 'cursor'>) =>
  infiniteQueryOptions({
    queryKey: ['org', 'organisation', 'list', q],
    queryFn: ({ pageParam }) => call(listOrganisations, { ...q, ...(pageParam && { cursor: pageParam }) }),
    initialPageParam: '' as string,
    getNextPageParam: (last) => last.nextCursor ?? undefined,
  });

export const organisationQuery = (id: string) =>
  queryOptions({ queryKey: ['org', 'organisation', id], queryFn: () => call(getOrganisation, { id }) });

export const contactsQuery = (q: Omit<In<typeof listContacts>, 'cursor'>) =>
  queryOptions({ queryKey: ['org', 'contact', 'list', q], queryFn: () => call(listContacts, { ...q, limit: 200 }) });
